import { Reveal, Chapter } from "./Reveal";

const CRITERIA = [
  { n: "01", name: "Hook Strength", q: "Cik spēcīgs ir stop scrolling efekts?", d: "Vērtējam galveno vizuālo elementu, headline un video gadījumā arī pirmās 2-3 sekundes." },
  { n: "02", name: "Message Clarity", q: "Vai cilvēks uzreiz saprot galveno vēstījumu?", d: "Potenciālajam klientam nevajadzētu mēģināt atšifrēt, ko uzņēmums vēlas pateikt." },
  { n: "03", name: "Creative Impact", q: "Vai kreatīvs izceļas un paliek atmiņā?", d: "Profesionāli noformēts vēl nenozīmē pamanāms." },
  { n: "04", name: "Value Proposition", q: "Vai cilvēkam ir skaidrs, kāpēc man tas ir vajadzīgs?", d: "Vērtējam, vai baneris vai video skaidri komunicē klienta ieguvumu, nevis tikai produkta īpašības." },
  { n: "05", name: "Supporting Proof", q: "Kāpēc cilvēkam vajadzētu Jums noticēt?", d: "Vērtējam atsauksmes, rezultātus, skaitļus, klientus, sertifikātus un citus uzticību veidojošos elementus." },
  { n: "06", name: "Visual Hierarchy", q: "Vai kreatīvs vada cilvēka uzmanību pareizajā secībā?", d: "Kas tiek pamanīts pirmais? Kas otrais? Vai galvenais vēstījums nepazūd? Vai skatītājs nonāk līdz CTA?" },
  { n: "07", name: "CTA Effectiveness", q: "Vai cilvēkam ir skaidrs, ko darīt tālāk?", d: "Kreatīvam ne tikai jāinformē. Tam jāvirza cilvēks uz nākamo soli." },
  { n: "08", name: "Brand Consistency", q: "Vai kreatīvs stiprina Jūsu zīmolu?", d: "Pārdošanas rezultāts nav jāpanāk uz zīmola identitātes un atpazīstamības rēķina." },
];

export default function Criteria() {
  return (
    <section id="kriteriji" data-testid="criteria-section" className="bg-white border-t border-black/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <Chapter number="04" label="Vērtēšanas kritēriji" />
        <Reveal>
          <h2 className="font-display font-black tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-[#003E75] max-w-4xl" data-testid="criteria-heading">
            8 kritēriji, pēc kuriem izvērtēsim{" "}
            <span className="text-[#003E75]/30">Jūsu banerus un video</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#003E75]/10 border border-black/10">
          {CRITERIA.map((c, i) => (
            <Reveal key={c.n} delay={(i % 4) * 0.06} className="bg-white">
              <div
                data-testid={`criterion-${c.n}`}
                className="group h-full p-7 hover:bg-[#003E75] transition-colors duration-300"
              >
                <span className="font-display font-black text-sm text-[#ED1C27] tracking-[0.2em]">{c.n}</span>
                <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-[#003E75] group-hover:text-white transition-colors duration-300">{c.name}</h3>
                <p className="mt-3 text-[#003E75]/80 group-hover:text-white/85 text-sm transition-colors duration-300">{c.q}</p>
                <p className="mt-2 text-[#003E75]/45 group-hover:text-white/50 text-xs leading-relaxed transition-colors duration-300">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
